export default __webpack_public_path__ + "static/media/luna.alt.31b1882b.png";